// Arabic strings for the external AI provider (aiprov stream) — DEVELOPMENT DRAFT by Claude (PD-011);
// unreviewed until decision H-10.
import type { enAiprov } from './en-aiprov.ts';
import type { Message } from './types.ts';

export const arAiprov: { readonly [K in keyof typeof enAiprov]: Message } = {
  // ------------------------------------------------------------ validation and API messages
  'ai.v.personal_data_not_allowed': 'لا يمكن إرسال البيانات الشخصية إلى مزوّد ذكاء اصطناعي خارجي إطلاقًا. أوقف البيانات الشخصية لاستخدام هذا المزوّد.',
  'ai.v.credential_required': 'خزّن مفتاح واجهة برمجية لهذا المزوّد (أو اطلب من المشغّل ضبط مفتاح للمنصة) قبل تشغيل الذكاء الاصطناعي.',
  'ai.api.credentialUnsupported': 'هذا المزوّد لا يستخدم مفتاح واجهة برمجية.',
  'ai.api.keyRingMissing': 'لا يمكن تخزين مفاتيح المزوّد لعدم ضبط حلقة مفاتيح التشفير.',
  'ai.api.testUnavailable': 'لا يمكن اختبار هذا المزوّد.',

  // ------------------------------------------------------------ outcomes (run and test)
  'ai.ui.reason.credential_rejected': 'رفض مزوّد الذكاء الاصطناعي مفتاح الواجهة البرمجية. لا يُعرض شيء.',
  'ai.ui.reason.rate_limited': 'مزوّد الذكاء الاصطناعي مشغول (تم تجاوز حدّ الطلبات). لا يُعرض شيء؛ حاول لاحقًا.',
  'ai.ui.reason.personal_data_not_allowed': 'لا يمكن إرسال البيانات الشخصية إلى مزوّد خارجي، لذلك لم يُرسل الطلب.',
  'ai.ui.reason.ok': 'تمت الإجابة',

  // ------------------------------------------------------------ provider key (write-only)
  'ai.ui.cred.title': 'مفتاح الواجهة البرمجية للمزوّد',
  'ai.ui.cred.intro': 'للكتابة فقط. يُختم المفتاح المخزّن ولا يُعرض مرة أخرى، ولا حتى للمسؤولين.',
  'ai.ui.cred.label': 'مفتاح واجهة برمجية جديد',
  'ai.ui.cred.hint': 'الصق المفتاح من حساب المزوّد. يحلّ محل أي مفتاح مخزّن لهذه المؤسسة.',
  'ai.ui.cred.save': 'تخزين المفتاح',
  'ai.ui.cred.remove': 'إزالة المفتاح المخزّن',
  'ai.ui.cred.statusOrganisation': 'مفتاح المؤسسة مخزّن (الإصدار {version}، {time}).',
  'ai.ui.cred.statusInstallation': 'لا يوجد مفتاح للمؤسسة: يُستخدم مفتاح المنصة الذي ضبطه المشغّل.',
  'ai.ui.cred.statusNone': 'لا يوجد مفتاح مخزّن. لا يمكن تشغيل الذكاء الاصطناعي مع هذا المزوّد بعد.',
  'ai.ui.cred.stored': 'تم تخزين المفتاح.',
  'ai.ui.cred.removed': 'تمت إزالة المفتاح المخزّن.',

  // ------------------------------------------------------------ connection test
  'ai.ui.test.button': 'اختبار الاتصال',
  'ai.ui.test.intro': 'يرسل طلبًا تجريبيًا لا يحتوي على أي بيانات من Passage، للتحقق من المفتاح والنموذج.',
  'ai.ui.test.ok': 'الاتصال يعمل: أجاب {model} خلال {ms} مللي ثانية ({input} رمز إدخال و{output} رمز إخراج).',
  'ai.ui.test.failed': 'فشل اختبار الاتصال: {reason}',
  'ai.ui.test.last': 'آخر اختبار {time}: {outcome}',

  // ------------------------------------------------------------ personal data and activity
  'ai.ui.personalExternal': 'لا تُرسل البيانات الشخصية إلى مزوّد خارجي أبدًا: تغادر Passage الأرقام المجمّعة ورموز الحقائق فقط (قرار المالك، 17 أكتوبر 2026).',
  'ai.ui.act.usage': 'الرموز',
  'ai.ui.act.usageValue': '{input} إدخال / {output} إخراج · {ms} مللي ثانية',
};
